import errorLogoPNG from "../../assets/images/error-logo.png";
import style from "./error.module.css";
function Generic(props) {
  const { message } = props;
  return (
    <div className={`${style.error_container}`}>
      <div className="d-flex flex-column align-items-center text-center">
        <img
          src={errorLogoPNG}
          alt="Logo Erro"
          className={`${style.error_size_image}`}
        />

        <div className={`text-light ${style.error_fs_text_warning} d-flex justify-content-center`}>
          <p className="text-center" style={{ width: "80%" }}>
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
export {
  Generic
};